"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_ALL = exports.BRAND_IOWA = exports.BRAND_PABETS = exports.BRAND_4NGBETS = exports.BRAND_FDR = exports.BRAND_TVG = void 0;
exports.BRAND_TVG = "tvg";
exports.BRAND_FDR = "fdr";
exports.BRAND_4NGBETS = "4njbets";
exports.BRAND_PABETS = "pabets";
exports.BRAND_IOWA = "iowa";
exports.BRAND_ALL = [
    exports.BRAND_TVG,
    exports.BRAND_FDR,
    exports.BRAND_4NGBETS,
    exports.BRAND_PABETS,
    exports.BRAND_IOWA
];
exports.default = (hostname) => {
    if (hostname) {
        if (/(nj|4njbets)(\.|-)/gi.test(hostname)) {
            return exports.BRAND_4NGBETS;
        }
        if (/(pa|pabets)(\.|-)/gi.test(hostname)) {
            return exports.BRAND_PABETS;
        }
        if (/ia(\.|-)/gi.test(hostname)) {
            return exports.BRAND_IOWA;
        }
        if (/fdbox|fanduel(\.|-)|racing/gi.test(hostname)) {
            return exports.BRAND_FDR;
        }
    }
    return exports.BRAND_TVG;
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/brand.js